<template>
  <div class="tab-temp">
    <div class="header">
      <div class="title">订单信息</div>
    </div>

    <div class="tab-temp-wrap border-bottom" v-if="order.peer_user && !hiddenSection.user">
      <div class="tab-temp-id clearfix">
        <div class="name">顾客电话</div>
        <div class="value">{{order.peer_user.mobile_phone}}</div>
      </div>
    </div>

    <div class="tab-temp-wrap border-bottom" v-if="!hiddenSection.contact">
      <div class="tab-temp-id clearfix">
        <div class="name">联系人姓名</div>
        <div class="value">{{order.contact_name}}</div>
      </div>
      <div class="tab-temp-info clearfix">
        <div class="name">电话号码</div>
        <div class="value">{{order.contact_number}}</div>
      </div>
      <div class="tab-temp-info clearfix" v-if="order.contact_email">
        <div class="name">联系邮箱</div>
        <div class="value">{{order.contact_email}}</div>
      </div>
    </div>

    <div class="tab-temp-wrap border-bottom" v-if="order.content  && !hiddenSection.contact">
      <div class="tab-temp-id clearfix">
        <div class="name">客户留言</div>
        <div class="value commens" v-text="order.content"></div>
      </div>
    </div>

    <div class="tab-temp-wrap" v-if="!hiddenSection.order">
      <div class="tab-temp-id clearfix">
        <div class="name">订单号</div>
        <div class="value">{{order.user_order_id}}</div>
      </div>
      <div class="tab-temp-info clearfix">
        <div class="name">商品名称</div>
        <div class="value">{{order.product_name}}</div>
      </div>
      <div class="tab-temp-info clearfix">
        <div class="name">订单状态</div>
        <div class="value">{{orderStatus[order.order_status]}}</div>
      </div>
      <div class="tab-temp-info clearfix">
        <div class="name">预计出行</div>
        <div class="value">{{order.depart_date}}</div>
      </div>
      <div class="tab-temp-info clearfix" v-if="order.effect_date">
        <div class="name">生效时间</div>
        <div class="value">{{order.effect_date}}</div>
      </div>
      <div class="tab-temp-info clearfix">
        <div class="name">下单时间</div>
        <div class="value">{{order.create_time}}</div>
      </div>
      <div class="tab-temp-date clearfix">
        <div class="name">支付时间</div>
        <div class="value">{{order.pay_time}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import status from '../../libs/status';
import pcdService from '../../services/pcd-service';

export default {
  name: 'orderBasicInfo',
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    peer: {
      type: Object,
      default() {
        return {};
      },
    },
    hiddenSection: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pcds: {},
      orderStatus: status.odStatus,
    };
  },
  methods: {
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
};
</script>

<style lang="less" scoped>
.tab-temp {
  background-color: #fff;
  padding-bottom: 1px;
  margin-top: 15px;
  .header{
    display: flex;
    align-items: center;
    height: 44px;
    background:linear-gradient(270deg,rgba(255,255,255,1) 0,rgba(242,247,255,1) 800px);
    padding: 0 20px;
    .title{
      color: #2F333D;
      font-size: 16px;
      font-weight: 600;
      margin-right: 12px;
    }
  }

  .tab-temp-wrap {
    font-size: 14px;
    line-height: 20px;
    background-color: #fff;
    margin: 0 24px 0 24px;
    padding: 16px 0;
    &>div {
      color: #333;
      margin-bottom: 8px;
      &:last-child{
        margin-bottom: 0;
      }
      .name {
        width: 96px;
        color: #91999F;
        float: left;
      }
      .value {
        margin-left: 100px;
        white-space: pre-wrap;
        color: #2F333D;
      }
      .commens {
        line-height: 18px;
      }
    }
    &.border-bottom {
      border-bottom: 1px solid #E9EEF2;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-basic-info.vue